import React, { Fragment } from "react";
import _ from "lodash";
import {Formik } from 'formik';
import {compose} from 'redux';
import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import {Dialog, DialogTitle, Grid, DialogContent} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import TextInput from 'components/Global/FormikMaterial/TextInput';
import TextAreaInput from 'components/Global/FormikMaterial/TextAreaInput';
import DecimalInput from 'components/Global/FormikMaterial/DecimalInput';
import AutoCompleteInput from 'components/Global/FormikMaterial/AutoCompleteInput';
import CheckboxSelectListInput from 'components/Global/FormikMaterial/CheckboxSelectListInput';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';

const FieldColumnWrapper = styled.div`
  display:flex;
  flex-direction:row;
  padding-bottom: 20px;
  min-height:300px;
`
const FieldColumn = styled.div`
  width:50%;
  padding: 0 8px;
`
const Block = styled.div`
  display:block;
  margin: 16px 0;
`
const styles = theme => ({
  dialogPaper: {
    'max-width':'815px',
    'font-size': '13px',        
  },
  dialogTitle: {
    color: 'blue',
    padding: '0 0 0 20px'
  },
  formLabelRoot: {
    
    marginTop: '30px',
    marginLeft: '5px',
  },
  checkboxRoot: {
    marginLeft: '20px',
    height: '32px'
  },
})

class Alert extends React.Component {
  onCancel = () => {
    this.props.onClose();
  }
  closeModal = () => {
    this.props.onClose();  
  };
  errorHandlingSubmit = (errors, handleSubmit) => {
    // Just for April 2019 demo. Normally the modal will only close afte a successful submit.
    this.closeModal();

    if(_.isEmpty(errors))
      handleSubmit();
  }
  

  render() {
    let { isOpen, classes,alert, indexOptions, testOptions, sendToOptions} = this.props;        
    return (
      <Fragment>        
        <Dialog open={isOpen} onClose={this.closeModal} fullWidth maxWidth="md" classes={{paper: classes.dialogPaper}}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between">
            <DialogTitle classes={{root: classes.dialogTitle}}>Alert</DialogTitle>
            <IconButton style={{ marginRight: 16, marginTop:5 }} onClick={this.closeModal}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
            
          </Grid>
        <DialogContent>
        <Formik 
              initialValues={alert}
              validateOnChange={false}
              validate={values => {                
                let errors ={}
                return errors;
              }}
              onSubmit={(values,{setSubmitting}) => {                            
                setSubmitting(false);
              }}
              render={({values,errors,status,touched, isSubmitting,handleChange, handleBlur,handleSubmit}) => (                  
                <Fragment>
                  <FieldColumnWrapper>
                    <FieldColumn>
                      <Block>
                        <TextInput fullWidth label='Alert for' fieldName="alertFor"/>
                      </Block>
                      <Block>
                        <AutoCompleteInput 
                          label="Index" 
                          fieldName="index"
                          options={indexOptions} />
                      </Block>
                      <Block>
                        <CheckboxSelectListInput
                          classes={classes}
                          label="Send to"
                          fieldName="sendTo"
                          options={sendToOptions}
                           />
                      </Block>
                    </FieldColumn>
                    <FieldColumn>
                      <Block>
                      <AutoCompleteInput 
                          label="Test" 
                          fieldName="test"
                          options={testOptions} />                        
                      </Block>
                      <Block>
                        <DecimalInput fullWidth label='Trigger' fieldName="trigger"/>
                      </Block>
                      <Block>
                        <TextAreaInput fullWidth label='Message' fieldName='message' />
                      </Block>
                    </FieldColumn>
                  </FieldColumnWrapper>
                  <Grid container direction="row" justify="flex-end">
                    <SecondaryButton onClick={this.onCancel}>Cancel</SecondaryButton>                    
                    <PrimaryButton onClick={() => this.errorHandlingSubmit(errors, handleSubmit)}>Save</PrimaryButton>
                  </Grid>
                </Fragment>
                )}/>
        
        </DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}

function mapStateToProps({configItems}) {
  return {
    
  };
}


export default compose(
  connect(
    mapStateToProps,
    {
    }
  ),
  withStyles(styles)
)(Alert);
